
<kendo-formfield>
    <kendo-label [text]="caption | translate"></kendo-label>
    <kendo-multiselect
    [ngClass]="{'fx-fill': settings.fxFill}"
    valuePrimitive="true"
    [data]="valuesList$ | async"
    [formControl]="control" 
    [textField]="textField" 
    [valueField]="valueField"
    [checkboxes]="true"
    [autoClose]="false"
    (valueChange)="onChange($event)">
</kendo-multiselect>
</kendo-formfield>

